import { render, staticRenderFns } from "./uclConfiguration.vue?vue&type=template&id=386880e8&"
import script from "./uclConfiguration.vue?vue&type=script&lang=js&"
export * from "./uclConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports